/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFavoritKontextEnum } from '../../models/lexplus-favorit-kontext-enum';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface FavoritenControllerAddV1$Params {
  kontextID: string;
  kontext: LexplusFavoritKontextEnum;
}

export function favoritenControllerAddV1(http: HttpClient, rootUrl: string, params: FavoritenControllerAddV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, favoritenControllerAddV1.PATH, 'put');
  if (params) {
    rb.path('kontextID', params.kontextID, {});
    rb.path('kontext', params.kontext, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

favoritenControllerAddV1.PATH = '/v1/favoriten/{kontext}/{kontextID}';
